import { useEffect, useState, useCallback } from "react";
import SendScheduleManager from "../../../components/admin/messages/SendScheduleManager";
import { getTemplateDropsDowns } from "../../../services/templateServices";
import { getGroupsOptions } from "../../../services/groupServices";
import { getScheduled } from "../../../services/sendSmsServices";

const SendAndSchedule = () => {
  const [templates, setTemplates] = useState([]);
  const [groups, setGroups] = useState([]);
  const [activeTab, setActiveTab] = useState("pending");

  const [messages, setMessages] = useState({
    pending: [],
    sent: [],
    failed: [],
  });

  const [lastIds, setLastIds] = useState({
    pending: null,
    sent: null,
    failed: null,
  });

  const [historyStacks, setHistoryStacks] = useState({
    pending: [],
    sent: [],
    failed: [],
  });

  const [hasMore, setHasMore] = useState({
    pending: false,
    sent: false,
    failed: false,
  });

  const [totalCount, setTotalCount] = useState({
    pending: 0,
    sent: 0,
    failed: 0,
  });

  const [loading, setLoading] = useState(true);
  const pageSize = 10;

  const fetchPaginatedMessages = useCallback(
    async (status, direction) => {
      try {
        const lastId =
          direction === "prev"
            ? historyStacks[status][historyStacks[status].length - 1]
            : lastIds[status];

        const response = await getScheduled({
          lastId: lastId || undefined,
          limit: pageSize,
          status,
        });

        setMessages((prev) => ({ ...prev, [status]: response.data.messages }));
        setLastIds((prev) => ({ ...prev, [status]: response.data.lastId }));
        setHasMore((prev) => ({ ...prev, [status]: response.data.hasMore }));
        setTotalCount((prev) => ({
          ...prev,
          [status]: response.data.totalCount,
        }));

        if (direction === "next" && response.data.messages.length) {
          setHistoryStacks((prev) => ({
            ...prev,
            [status]: [...prev[status], lastId ?? ""].filter(Boolean),
          }));
        }

        if (direction === "prev") {
          setHistoryStacks((prev) => ({
            ...prev,
            [status]: prev[status].slice(0, -1),
          }));
        }
      } catch (error) {
        console.error(`Failed to fetch ${status} messages:`, error);
      }
    },
    [lastIds, historyStacks]
  );

  const refreshCurrentTab = useCallback(async () => {
    await fetchPaginatedMessages(activeTab);
  }, [activeTab, fetchPaginatedMessages]);

  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const [templateRes, groupRes] = await Promise.all([
          getTemplateDropsDowns(),
          getGroupsOptions(),
        ]);
        setTemplates(templateRes.data);
        setGroups(groupRes.data);
      } catch (err) {
        console.error("Dropdown fetch failed", err);
      }
    };

    const init = async () => {
      setLoading(true);
      await fetchDropdowns();
      await fetchPaginatedMessages("pending");
      setLoading(false);
    };

    init();
  }, []);

  // When tab changes, load that tab's data if not already loaded
  useEffect(() => {
    if (messages[activeTab].length === 0) {
      fetchPaginatedMessages(activeTab);
    }
  }, [activeTab]);

  if (loading) return <div text="Loading..." />;

  return (
    <div className="h-screen !overflow-hidden">
      <SendScheduleManager
        activeTab={activeTab}
        onTabChange={setActiveTab}
        templates={templates}
        groups={groups}
        messages={messages}
        hasMore={hasMore}
        totalCount={totalCount}
        onPaginate={fetchPaginatedMessages}
        refreshSchedule={refreshCurrentTab}
        historyStacks={historyStacks}
      />
    </div>
  );
};

export default SendAndSchedule;
